/** Restart a CSS animation on an element without remounting it. */
export function flashElement(el: HTMLElement) {
  el.style.animation = 'none';
  void el.offsetHeight; // force reflow
  el.style.animation = 'fadeSlideIn 0.2s ease-out';
}
